if (!customElements.get('sons-product-share')) {
  customElements.define('sons-product-share', class extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    shareUrl() {
      const url = new URL(this.dataset.productUrl || window.location.pathname, window.location.origin);
      const current = new URL(window.location.href);
      const variantId = current.searchParams.get('variant');
      // El selector de variantes de Horizon actualiza ?variant= en la URL de la PDP.
      if (current.pathname === url.pathname && variantId && /^\d+$/.test(variantId)) {
        url.searchParams.set('variant', variantId);
      }
      return url.href;
    }

    async copyLink(forInstagram = false) {
      const field = /** @type {HTMLInputElement | null} */ (this.querySelector('[data-share-url]'));
      const status = this.querySelector('[data-copy-status]');
      if (!field || !status) return;
      field.value = this.shareUrl();
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(field.value);
        status.textContent = forInstagram ? 'Enlace copiado. Pégalo en Instagram Direct.' : 'Enlace copiado.';
        field.hidden = true;
      } catch (_) {
        status.textContent = forInstagram ? 'Copia el enlace para pegarlo en Instagram Direct:' : 'Selecciona y copia este enlace:';
        field.hidden = false;
        field.select();
      }
    }

    /** @param {HTMLAnchorElement} link */
    shareLink(link) {
      const url = this.shareUrl();
      const text = `Mira ${this.dataset.productTitle} en Sons of Camper`;
      const destinations = {
        whatsapp: () => `https://wa.me/?text=${encodeURIComponent(`${text}: ${url}`)}`,
        facebook: () => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
        x: () => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
        telegram: () => `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      };
      const network = /** @type {keyof typeof destinations} */ (link.dataset.shareNetwork);
      if (destinations[network]) link.href = destinations[network]();
    }

    async showQr() {
      const dialog = /** @type {HTMLDialogElement | null} */ (this.querySelector('[data-qr-dialog]'));
      const image = dialog?.querySelector('[data-qr-image]');
      const error = /** @type {HTMLElement | null | undefined} */ (dialog?.querySelector('[data-qr-error]'));
      if (!dialog || !image || !error || !this.dataset.qrModule) return;
      image.replaceChildren();
      error.hidden = true;
      dialog.showModal();
      try {
        const {QRCode} = await import(this.dataset.qrModule);
        if (!dialog.open) return;
        new QRCode(image, {
          text: this.shareUrl(), width: 256, height: 256,
          correctLevel: QRCode.CorrectLevel.M, alt: 'Código QR del producto',
        });
      } catch (_) {
        error.textContent = 'No se pudo generar el QR. Inténtalo de nuevo.';
        error.hidden = false;
      }
    }

    /** @param {MouseEvent} event */
    onClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const networkLink = /** @type {HTMLAnchorElement | null} */ (target.closest('[data-share-network]'));
      if (networkLink) {
        this.shareLink(networkLink);
      } else if (target.closest('[data-share-instagram]')) {
        // Instagram no permite rellenar mensajes directos desde un enlace web.
        this.copyLink(true);
      } else if (target.closest('[data-copy-link]')) {
        this.copyLink();
      } else if (target.closest('[data-show-qr]')) {
        this.showQr();
      } else if (target.closest('[data-close-qr]')) {
        /** @type {HTMLDialogElement | null} */ (this.querySelector('[data-qr-dialog]'))?.close();
      }
    }
  });
}
